import React from "react";
import { AnalyzersViewWrap } from "./AnalyzersViewWrap";

const AnalyzersReactView = () => {
  return <AnalyzersViewWrap />;
};

window.AnalyzersReactView = AnalyzersReactView;
